import Axios from 'axios';
var PageService = (function () {
    function PageService() {
    }
    PageService.prototype.getPage = function (params) {
        return Axios.get('supplierclientapi/page/get', { params: params });
    };
    PageService.prototype.updatePage = function (params) {
        return Axios.post('supplierclientapi/page/update', params);
    };
    PageService.createInstance = function () {
        PageService.getInstance();
    };
    PageService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return PageService;
}());
export default PageService;
